import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import AboutSection from '../components/AboutSection';
import AdminPanel from '../components/AdminPanel';
import ArtDetailModal from '../components/ArtDetailModal';
import Copyright from '../components/Copyright';
import EventSplashModal from '../components/EventSplashModal';
import HeroSection from '../components/HeroSection';
import MasonryGallery from '../components/MasonryGallery';
import NavBar from '../components/NavBar';
import { useArtList } from '../contexts/ArtListProvider';

const HomePage: React.FC = () => {
    const { artList, loading } = useArtList();
    const [selectedArtId, setSelectedArtId] = useState<number | null>(null);
    const selectedArt = artList.find((a) => a.id === selectedArtId) ?? null;

    useEffect(() => {
        const hash = window.location.hash.slice(1);
        if (hash) {
            setTimeout(() => {
                document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }, []);

    return (
        <Box sx={{ minHeight: '100vh' }}>
            <NavBar />
            <HeroSection />

            <Box id="gallery" sx={{ pt: 8, pb: 6 }}>
                <Typography
                    variant="h2"
                    sx={{
                        px: { xs: 2, md: 4 },
                        mb: 4,
                        fontSize: { xs: '2rem', md: '3rem' },
                    }}
                >
                    Works
                </Typography>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
                        <CircularProgress sx={{ color: 'primary.main' }} />
                    </Box>
                ) : (
                    <MasonryGallery artList={artList} onArtClick={setSelectedArtId} />
                )}
            </Box>

            <AboutSection />
            <Copyright />

            <EventSplashModal />
            <AdminPanel />
            <ArtDetailModal
                art={selectedArt}
                artList={artList}
                onClose={() => setSelectedArtId(null)}
                onNavigate={setSelectedArtId}
            />
        </Box>
    );
};

export default HomePage;
